import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const SaveSegmentDialog = ({ open, onOpenChange, q, filters }) => {
  const [segName, setSegName] = useState("");

  const save = async () => {
    try {
      const { data: seg } = await api.post("/segments", { name: segName, filters: { q, ...filters } });
      toast.success(`Saved "${seg.name}" as a group (${seg.count} customers). Find it on the Send an Email page.`);
      onOpenChange(false);
      setSegName("");
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle className="font-serif text-2xl">Save these filters as a group</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Saved groups can be used to send emails or generate statements for just these customers.</p>
        <div className="space-y-1.5">
          <Label>Group name</Label>
          <Input value={segName} onChange={(e) => setSegName(e.target.value)} placeholder="e.g. Big supporters" data-testid="segment-dialog-name-input" />
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={!segName.trim()} data-testid="segment-dialog-save-btn">Save group</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
